import {takeEvery, put} from 'redux-saga/effects';

import {changeUhcAllowanceItem} from '../../reducers/applyingAllowance/applyingAllowance';
import {getQuote} from '../../reducers/quoteItems/quoteItems';

/**
 * Update quote data after changing cart item with applied allowance
 */
function* updateQuote() {
    yield put(getQuote({}));
}

/**
 * Listeners for uhc stuff
 */
export default function* uhc() {
    yield takeEvery(`${changeUhcAllowanceItem.fulfilled}`, updateQuote);
}
